import styled from 'styled-components';

export const ErrorBoundaryStyles = styled.section`
  color: ${(props) => props.theme.palette?.background?.paper};
  text-align: center;
  margin-top: 20vh;
`;
